<template>
    <el-row :gutter="15" style="margin: 10px">
        <el-col :span="3">
            <el-input v-on:keyup.native.enter="search" size="mini" :clearable="true" placeholder="订单号"
                      v-model.trim="id">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </el-col>

        <el-col :span="3">
            <el-input v-on:keyup.native.enter="search" size="mini" :clearable="true" placeholder="款号"
                      v-model.trim="baseId">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </el-col>
        <el-col :span="4">
            <el-cascader
                    size="mini"
                    popper-class="_create_group_craft"
                    v-model="group"
                    filterable
                    placeholder="请选择"
                    :show-all-levels="false"
                    :options="CasCaderOptions"
                    @change="selectChange"
                    :props="{ expandTrigger: 'hover' }">
                <i slot="prefix" :class="selectClass"></i>
            </el-cascader>

        </el-col>
        <el-col :span="1">
            <el-button :loading="searchLoading" @click="search" type="primary" size="mini">搜索</el-button>
        </el-col>
        <el-col :span="2">
            <el-button icon="el-icon-refresh" :loading="refreshLoading" @click="refresh" type="primary" size="mini">刷新
            </el-button>
        </el-col>
        <slot>

        </slot>
    </el-row>
</template>

<script>
    import setting from "../../plugins/setting"
    import {mapMutations, mapGetters} from 'vuex'

    export default {
        name: "GroupOrderSearch",
        props: {
            searchUrl: {
                type: String,
                required: false,
                default: `${setting.data.craftGroupRecordUrl}?finish=true&limit=20`
            },
            refreshUrl: {
                type: String,
                required: false,
                default: `${setting.data.craftGroupRecordUrl}?finish=true&limit=20`
            },
            handleSearch: {
                type: Function,
                required: true,
            },
            handleReFresh: {
                type: Function,
                required: true,
            },
        },
        data() {
            return {
                id: '',
                baseId: '',
                group: '',

                selectLoading: false,
                searchLoading: false,
                refreshLoading: false,

                selectClass: 'el-input__icon',
            }
        },
        computed: {
            ...mapGetters(["CasCaderOptions"]),
        },
        methods: {
            selectChange(change) {
                let url = ''
                if (change) {
                    // change 是 级联selector 真正的 produce_group 信息在数组的叶子节点[最后一位]
                    // change 的长度为 2， 所有通过 change[1] 获取 produce_group
                    url = `${this.searchUrl}&produce_group=${change[1]}`
                } else {
                    url = this.searchUrl
                }

                this.selectClass = 'el-input__icon el-icon-loading'
                this.selectLoading = true
                this.$getRequest(url)
                    .then(response => {
                        this.selectLoading = false
                        this.selectClass = 'el-input__icon'
                        this.handleSearch(response)
                    })
                    .catch(error => {
                        this.selectLoading = false
                        this.selectClass = 'el-input__icon'
                    })
            },
            search() {
                this.searchLoading = true
                const params = {}
                if (this.id) {
                    params['id'] = parseInt(this.id.substring(this.id.length - 5))
                }

                if (this.baseId) {
                    params['base_id'] = this.baseId
                }
                this.$getRequest(this.searchUrl, params)
                    .then(response => {
                        this.searchLoading = false
                        this.handleSearch(response)
                    })
                    .catch(error => {
                        this.searchLoading = false
                    })
            },
            refresh() {
                this.refreshLoading = true
                this.$getRequest(this.refreshUrl)
                    .then(response => {
                        this.refreshLoading = false
                        this.handleReFresh(response)
                    })
                    .catch(error => {
                        this.refreshLoading = false
                    })
            },
            ...mapMutations(['setProduceGroups'])
        },
    }
</script>

<style>
    .__group__order__popper .el-scrollbar {
        width: 320px;
    }

</style>